import styled from "styled-components";

export const StepsContainer = styled.div`
  background: #fafbfc;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 20px;
`;

export const IframeContainer = styled.div`
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
  background: #fff;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 20px 0 8px;
`;

export const TimeoutMessage = styled.div`
  text-align: center;
  padding: 28px 24px;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 10px;
  margin-top: 16px;
`;
